{
  "three-acts": {
    "name": "Tres actos",
    "summary": "Planteamiento, confrontación y resolución: la forma que comparten la mayoría de las novelas y películas.",
    "bestFor": "Cualquier género y un primer borrador que quieras mantener sencillo.",
    "metaTitle": "Plantilla narrativa de tres actos — Musael",
    "metaDescription": "Planteamiento, confrontación y resolución: la forma de muchas novelas y películas. Para cualquier género y un primer borrador sencillo.",
    "acts": [
      {
        "title": "Acto I: Planteamiento",
        "synopsis": "Quién es el protagonista, qué quiere y el suceso que pone fin a su vida normal.",
        "chapters": [
          {
            "title": "El mundo cotidiano",
            "synopsis": "El protagonista en su entorno, con el deseo y el defecto que la historia pondrá a prueba.",
            "scenes": [
              {
                "title": "Imagen inicial",
                "synopsis": "Una instantánea del protagonista antes de que algo cambie."
              },
              {
                "title": "El gancho",
                "synopsis": "Algo pequeño pero extraño que anuncia problemas."
              }
            ]
          },
          {
            "title": "El incidente desencadenante",
            "synopsis": "El suceso que el protagonista no puede ignorar.",
            "scenes": [
              {
                "title": "Incidente desencadenante",
                "synopsis": "El problema llega y no desaparece."
              },
              {
                "title": "Dilema",
                "synopsis": "El protagonista duda y vemos lo que puede perder."
              }
            ]
          },
          {
            "title": "Cruce del umbral",
            "synopsis": "El protagonista se compromete; volver atrás ya no es fácil.",
            "scenes": [
              {
                "title": "La decisión",
                "synopsis": "El protagonista decide actuar y deja atrás lo conocido."
              }
            ]
          }
        ]
      },
      {
        "title": "Acto II: Confrontación",
        "synopsis": "El protagonista intenta, falla y aprende mientras aumenta lo que está en juego.",
        "chapters": [
          {
            "title": "Aumenta lo que está en juego",
            "synopsis": "Nuevas reglas, aliados y enemigos; las primeras victorias tienen un precio.",
            "scenes": [
              {
                "title": "Primera prueba",
                "synopsis": "El protagonista conoce el nuevo mundo y se equivoca en parte al interpretarlo."
              },
              {
                "title": "Aliados y enemigos",
                "synopsis": "Quién ayuda, quién obstaculiza y por qué."
              }
            ]
          },
          {
            "title": "El punto medio",
            "synopsis": "Un giro que cambia de qué trata la historia.",
            "scenes": [
              {
                "title": "Punto medio",
                "synopsis": "Una falsa victoria o derrota; el protagonista deja de reaccionar y toma la iniciativa."
              }
            ]
          },
          {
            "title": "Todo se desmorona",
            "synopsis": "La oposición se acerca y el defecto le cuesta caro al protagonista.",
            "scenes": [
              {
                "title": "La presión",
                "synopsis": "Todos los planes encuentran resistencia; las relaciones se agrietan."
              },
              {
                "title": "Todo está perdido",
                "synopsis": "El punto más bajo: el objetivo parece inalcanzable para siempre."
              }
            ]
          }
        ]
      },
      {
        "title": "Acto III: Resolución",
        "synopsis": "El protagonista cambia, afronta la prueba final y comienza una nueva normalidad.",
        "chapters": [
          {
            "title": "El clímax",
            "synopsis": "La confrontación final, ganada gracias a la lección del segundo acto.",
            "scenes": [
              {
                "title": "El plan final",
                "synopsis": "El protagonista reúne lo aprendido y hace un último intento."
              },
              {
                "title": "Clímax",
                "synopsis": "La confrontación decisiva."
              }
            ]
          },
          {
            "title": "La nueva normalidad",
            "synopsis": "Qué cambió para el protagonista y para el mundo.",
            "scenes": [
              {
                "title": "Imagen de cierre",
                "synopsis": "Un reflejo de la imagen inicial que muestra cuánto ha avanzado el protagonista."
              }
            ]
          }
        ]
      }
    ]
  },
  "heros-journey": {
    "name": "El viaje del héroe",
    "summary": "Doce etapas desde la llamada a la aventura hasta el regreso a casa, agrupadas en partida, iniciación y regreso.",
    "bestFor": "Fantasía, aventuras y búsquedas.",
    "metaTitle": "Plantilla del viaje del héroe — Musael",
    "metaDescription": "Doce etapas de la llamada a la aventura al regreso a casa, en partida, iniciación y regreso. Para fantasía, aventuras y búsquedas.",
    "acts": [
      {
        "title": "Partida",
        "synopsis": "El protagonista abandona el mundo conocido.",
        "chapters": [
          {
            "title": "El mundo cotidiano",
            "synopsis": "El protagonista antes de la aventura: hogar, hábitos y lo que le falta.",
            "scenes": [
              {
                "title": "El mundo cotidiano",
                "synopsis": "El protagonista antes de la aventura: hogar, hábitos y lo que le falta."
              }
            ]
          },
          {
            "title": "La llamada a la aventura",
            "synopsis": "Un desafío o un mensaje altera el mundo cotidiano.",
            "scenes": [
              {
                "title": "La llamada a la aventura",
                "synopsis": "Un desafío o un mensaje altera el mundo cotidiano."
              }
            ]
          },
          {
            "title": "Rechazo de la llamada",
            "synopsis": "El miedo o el deber frenan al protagonista.",
            "scenes": [
              {
                "title": "Rechazo de la llamada",
                "synopsis": "El miedo o el deber frenan al protagonista."
              }
            ]
          },
          {
            "title": "Encuentro con el mentor",
            "synopsis": "Alguien ofrece consejo, formación o un regalo.",
            "scenes": [
              {
                "title": "Encuentro con el mentor",
                "synopsis": "Alguien ofrece consejo, formación o un regalo."
              }
            ]
          },
          {
            "title": "Cruce del primer umbral",
            "synopsis": "El protagonista entra en el mundo extraordinario.",
            "scenes": [
              {
                "title": "Cruce del primer umbral",
                "synopsis": "El protagonista entra en el mundo extraordinario."
              }
            ]
          }
        ]
      },
      {
        "title": "Iniciación",
        "synopsis": "Pruebas en el mundo extraordinario y la gran prueba.",
        "chapters": [
          {
            "title": "Pruebas, aliados y enemigos",
            "synopsis": "El protagonista aprende las reglas del nuevo mundo.",
            "scenes": [
              {
                "title": "Pruebas, aliados y enemigos",
                "synopsis": "El protagonista aprende las reglas del nuevo mundo."
              }
            ]
          },
          {
            "title": "Acercamiento a la cueva más profunda",
            "synopsis": "Preparativos para el peligro central.",
            "scenes": [
              {
                "title": "Acercamiento a la cueva más profunda",
                "synopsis": "Preparativos para el peligro central."
              }
            ]
          },
          {
            "title": "La gran prueba",
            "synopsis": "Una crisis de vida o muerte; algo dentro del protagonista muere.",
            "scenes": [
              {
                "title": "La gran prueba",
                "synopsis": "Una crisis de vida o muerte; algo dentro del protagonista muere."
              }
            ]
          },
          {
            "title": "La recompensa",
            "synopsis": "El protagonista obtiene el tesoro, el conocimiento o la reconciliación.",
            "scenes": [
              {
                "title": "La recompensa",
                "synopsis": "El protagonista obtiene el tesoro, el conocimiento o la reconciliación."
              }
            ]
          }
        ]
      },
      {
        "title": "Regreso",
        "synopsis": "El camino a casa, una última prueba y lo que el protagonista trae consigo.",
        "chapters": [
          {
            "title": "El camino de regreso",
            "synopsis": "El protagonista vuelve a casa, a menudo perseguido.",
            "scenes": [
              {
                "title": "El camino de regreso",
                "synopsis": "El protagonista vuelve a casa, a menudo perseguido."
              }
            ]
          },
          {
            "title": "Resurrección",
            "synopsis": "Una prueba final que exige usar todo lo aprendido.",
            "scenes": [
              {
                "title": "Resurrección",
                "synopsis": "Una prueba final que exige usar todo lo aprendido."
              }
            ]
          },
          {
            "title": "Regreso con el elixir",
            "synopsis": "El protagonista vuelve a casa transformado, con algo que compartir.",
            "scenes": [
              {
                "title": "Regreso con el elixir",
                "synopsis": "El protagonista vuelve a casa transformado, con algo que compartir."
              }
            ]
          }
        ]
      }
    ]
  },
  "fifteen-beats": {
    "name": "Esquema de quince hitos",
    "summary": "El esquema que usan los guionistas: quince puntos de giro repartidos en tres actos.",
    "bestFor": "Tramas comerciales compactas, con giros claros.",
    "metaTitle": "Plantilla narrativa de quince hitos — Musael",
    "metaDescription": "El esquema de los guionistas: quince giros en tres actos. Para tramas comerciales compactas, con puntos de giro claros.",
    "acts": [
      {
        "title": "Acto I",
        "synopsis": "El mundo de antes y la decisión de dejarlo atrás.",
        "chapters": [
          {
            "title": "Imagen inicial",
            "synopsis": "El protagonista y el mundo antes de la historia.",
            "scenes": [
              {
                "title": "Imagen inicial",
                "synopsis": "El protagonista y el mundo antes de la historia."
              }
            ]
          },
          {
            "title": "Presentación del tema",
            "synopsis": "Alguien dice de qué trata realmente la historia; el protagonista aún no lo comprende.",
            "scenes": [
              {
                "title": "Presentación del tema",
                "synopsis": "Alguien dice de qué trata realmente la historia; el protagonista aún no lo comprende."
              }
            ]
          },
          {
            "title": "Planteamiento",
            "synopsis": "La vida del protagonista, las personas que la rodean y lo que necesita arreglar.",
            "scenes": [
              {
                "title": "Planteamiento",
                "synopsis": "La vida del protagonista, las personas que la rodean y lo que necesita arreglar."
              }
            ]
          },
          {
            "title": "Catalizador",
            "synopsis": "El suceso que pone en marcha la historia.",
            "scenes": [
              {
                "title": "Catalizador",
                "synopsis": "El suceso que pone en marcha la historia."
              }
            ]
          },
          {
            "title": "Dilema",
            "synopsis": "El protagonista duda sobre qué hacer.",
            "scenes": [
              {
                "title": "Dilema",
                "synopsis": "El protagonista duda sobre qué hacer."
              }
            ]
          },
          {
            "title": "Entrada al segundo acto",
            "synopsis": "El protagonista elige un nuevo camino.",
            "scenes": [
              {
                "title": "Entrada al segundo acto",
                "synopsis": "El protagonista elige un nuevo camino."
              }
            ]
          }
        ]
      },
      {
        "title": "Acto II",
        "synopsis": "La promesa de la premisa y, después, la caída.",
        "chapters": [
          {
            "title": "Trama secundaria",
            "synopsis": "Una historia secundaria, a menudo una relación, que desarrolla el tema.",
            "scenes": [
              {
                "title": "Trama secundaria",
                "synopsis": "Una historia secundaria, a menudo una relación, que desarrolla el tema."
              }
            ]
          },
          {
            "title": "Diversión y juegos",
            "synopsis": "La premisa se hace realidad: lo que los lectores vinieron a buscar.",
            "scenes": [
              {
                "title": "Diversión y juegos",
                "synopsis": "La premisa se hace realidad: lo que los lectores vinieron a buscar."
              }
            ]
          },
          {
            "title": "Punto medio",
            "synopsis": "Una falsa victoria o derrota aumenta lo que está en juego.",
            "scenes": [
              {
                "title": "Punto medio",
                "synopsis": "Una falsa victoria o derrota aumenta lo que está en juego."
              }
            ]
          },
          {
            "title": "Los adversarios se acercan",
            "synopsis": "Dudas por dentro, presión por fuera.",
            "scenes": [
              {
                "title": "Los adversarios se acercan",
                "synopsis": "Dudas por dentro, presión por fuera."
              }
            ]
          },
          {
            "title": "Todo está perdido",
            "synopsis": "Lo opuesto al punto medio: el momento más bajo.",
            "scenes": [
              {
                "title": "Todo está perdido",
                "synopsis": "Lo opuesto al punto medio: el momento más bajo."
              }
            ]
          },
          {
            "title": "La noche oscura del alma",
            "synopsis": "El protagonista lamenta lo perdido y encuentra la lección.",
            "scenes": [
              {
                "title": "La noche oscura del alma",
                "synopsis": "El protagonista lamenta lo perdido y encuentra la lección."
              }
            ]
          }
        ]
      },
      {
        "title": "Acto III",
        "synopsis": "La lección puesta en práctica.",
        "chapters": [
          {
            "title": "Entrada al tercer acto",
            "synopsis": "Una nueva idea, surgida de la trama secundaria, abre un camino.",
            "scenes": [
              {
                "title": "Entrada al tercer acto",
                "synopsis": "Una nueva idea, surgida de la trama secundaria, abre un camino."
              }
            ]
          },
          {
            "title": "Final",
            "synopsis": "El protagonista arregla lo que estaba roto y cambia para siempre.",
            "scenes": [
              {
                "title": "Final",
                "synopsis": "El protagonista arregla lo que estaba roto y cambia para siempre."
              }
            ]
          },
          {
            "title": "Imagen final",
            "synopsis": "El mundo después, como reflejo de la imagen inicial.",
            "scenes": [
              {
                "title": "Imagen final",
                "synopsis": "El mundo después, como reflejo de la imagen inicial."
              }
            ]
          }
        ]
      }
    ]
  },
  "seven-point": {
    "name": "Estructura de siete puntos",
    "summary": "Planifica desde el final hacia atrás: gancho, giros, presiones, punto medio y resolución.",
    "bestFor": "Escritores que conocen primero el final.",
    "metaTitle": "Plantilla narrativa de siete puntos — Musael",
    "metaDescription": "Planifica desde el final: gancho, giros, presiones, punto medio y resolución. Para escritores que conocen primero el desenlace.",
    "acts": [
      {
        "title": "",
        "synopsis": "",
        "chapters": [
          {
            "title": "Gancho",
            "synopsis": "El estado inicial, opuesto al de la resolución.",
            "scenes": [
              {
                "title": "Gancho",
                "synopsis": "El estado inicial, opuesto al de la resolución."
              }
            ]
          },
          {
            "title": "Giro de trama 1",
            "synopsis": "Empieza el conflicto y el protagonista se ve impulsado a actuar.",
            "scenes": [
              {
                "title": "Giro de trama 1",
                "synopsis": "Empieza el conflicto y el protagonista se ve impulsado a actuar."
              }
            ]
          },
          {
            "title": "Presión 1",
            "synopsis": "El antagonista ejerce presión; el protagonista tiene que actuar.",
            "scenes": [
              {
                "title": "Presión 1",
                "synopsis": "El antagonista ejerce presión; el protagonista tiene que actuar."
              }
            ]
          },
          {
            "title": "Punto medio",
            "synopsis": "El protagonista pasa de reaccionar a actuar.",
            "scenes": [
              {
                "title": "Punto medio",
                "synopsis": "El protagonista pasa de reaccionar a actuar."
              }
            ]
          },
          {
            "title": "Presión 2",
            "synopsis": "Las cosas salen muy mal; el plan fracasa.",
            "scenes": [
              {
                "title": "Presión 2",
                "synopsis": "Las cosas salen muy mal; el plan fracasa."
              }
            ]
          },
          {
            "title": "Giro de trama 2",
            "synopsis": "El protagonista consigue la última pieza que necesita para ganar.",
            "scenes": [
              {
                "title": "Giro de trama 2",
                "synopsis": "El protagonista consigue la última pieza que necesita para ganar."
              }
            ]
          },
          {
            "title": "Resolución",
            "synopsis": "El estado final, la respuesta al gancho.",
            "scenes": [
              {
                "title": "Resolución",
                "synopsis": "El estado final, la respuesta al gancho."
              }
            ]
          }
        ]
      }
    ]
  },
  "kishotenketsu": {
    "name": "Kishōtenketsu",
    "summary": "Cuatro movimientos construidos sobre un giro en lugar de un conflicto.",
    "bestFor": "Ficción literaria, cuentos y libros pausados centrados en los personajes.",
    "metaTitle": "Plantilla narrativa Kishōtenketsu — Musael",
    "metaDescription": "Cuatro movimientos basados en un giro, no en un conflicto. Para ficción literaria, cuentos y libros pausados centrados en personajes.",
    "acts": [
      {
        "title": "",
        "synopsis": "",
        "chapters": [
          {
            "title": "Ki: introducción",
            "synopsis": "Los personajes y su mundo, con calma.",
            "scenes": [
              {
                "title": "Introducción",
                "synopsis": "Quién, dónde y cómo es la vida cotidiana."
              }
            ]
          },
          {
            "title": "Shō: desarrollo",
            "synopsis": "La situación se profundiza, todavía sin un giro.",
            "scenes": [
              {
                "title": "Desarrollo",
                "synopsis": "Conocemos mejor a los personajes; pequeñas cosas cambian."
              }
            ]
          },
          {
            "title": "Ten: giro",
            "synopsis": "Un elemento inesperado cambia nuestra forma de verlo todo.",
            "scenes": [
              {
                "title": "El giro",
                "synopsis": "Llega algo nuevo, aparentemente sin relación."
              }
            ]
          },
          {
            "title": "Ketsu: integración",
            "synopsis": "Las partes se unen y dan lugar a una nueva comprensión.",
            "scenes": [
              {
                "title": "Integración",
                "synopsis": "El giro y la historia se encuentran; el significado cambia."
              }
            ]
          }
        ]
      }
    ]
  },
  "mystery": {
    "name": "Misterio",
    "summary": "Un crimen, una investigación entre pistas y falsas pistas, y una revelación justa con el lector.",
    "bestFor": "Novelas criminales, detectivescas y misterios cozy.",
    "metaTitle": "Plantilla narrativa de misterio — Musael",
    "metaDescription": "Un crimen, pistas y falsas pistas, y una revelación justa con el lector. Para novelas criminales, detectivescas y misterios cozy.",
    "acts": [
      {
        "title": "El crimen",
        "synopsis": "Algo anda mal y alguien tiene que descubrir por qué.",
        "chapters": [
          {
            "title": "El descubrimiento",
            "synopsis": "El crimen o la desaparición.",
            "scenes": [
              {
                "title": "El cuerpo",
                "synopsis": "Se descubre el crimen; primeras impresiones y primeras preguntas."
              },
              {
                "title": "El detective",
                "synopsis": "Quién investiga y por qué le importa."
              }
            ]
          }
        ]
      },
      {
        "title": "La investigación",
        "synopsis": "Pistas, sospechosos y falsas pistas.",
        "chapters": [
          {
            "title": "Sospechosos",
            "synopsis": "Todos los que tienen un motivo y una coartada.",
            "scenes": [
              {
                "title": "Entrevistas",
                "synopsis": "Cada sospechoso tiene una razón para mentir."
              },
              {
                "title": "La primera pista",
                "synopsis": "Un dato que importará después; juega limpio con el lector."
              }
            ]
          },
          {
            "title": "Falsas pistas",
            "synopsis": "La investigación toma el camino equivocado.",
            "scenes": [
              {
                "title": "Una pista engañosa",
                "synopsis": "Las pruebas señalan a la persona equivocada."
              },
              {
                "title": "Escalada",
                "synopsis": "Un segundo crimen o una amenaza aumenta lo que está en juego."
              }
            ]
          },
          {
            "title": "La verdad oculta",
            "synopsis": "El detective ve lo que siempre estuvo ahí.",
            "scenes": [
              {
                "title": "La pieza que falta",
                "synopsis": "Un pequeño detalle hace encajar las pistas anteriores."
              }
            ]
          }
        ]
      },
      {
        "title": "La revelación",
        "synopsis": "La solución y su precio.",
        "chapters": [
          {
            "title": "La solución",
            "synopsis": "Se explica cada pista.",
            "scenes": [
              {
                "title": "La revelación",
                "synopsis": "Se identifica al culpable y se expone el razonamiento."
              },
              {
                "title": "Consecuencias",
                "synopsis": "La justicia, o su ausencia, y lo que el detective se lleva consigo."
              }
            ]
          }
        ]
      }
    ]
  },
  "romance": {
    "name": "Romance",
    "summary": "Dos personas, lo que las separa y lo que necesitan para elegirse.",
    "bestFor": "Romances e historias de amor en cualquier ambientación.",
    "metaTitle": "Plantilla narrativa romántica — Musael",
    "metaDescription": "Dos personas, lo que las separa y lo que necesitan para elegirse. Para romances e historias de amor en cualquier ambientación.",
    "acts": [
      {
        "title": "Enamorarse",
        "synopsis": "Se conocen, se resisten y empiezan a enamorarse.",
        "chapters": [
          {
            "title": "El encuentro",
            "synopsis": "El primer encuentro, con la chispa y el obstáculo.",
            "scenes": [
              {
                "title": "Encuentro",
                "synopsis": "Los dos protagonistas se conocen; algo del otro les llega muy adentro."
              },
              {
                "title": "Resistencia",
                "synopsis": "Por qué esto no puede funcionar: objetivos, heridas o circunstancias."
              }
            ]
          },
          {
            "title": "Acercamiento",
            "synopsis": "Obligados a compartir espacio, se ven como realmente son.",
            "scenes": [
              {
                "title": "Juntos por casualidad",
                "synopsis": "Una situación los mantiene cerca."
              },
              {
                "title": "El primer momento auténtico",
                "synopsis": "Un vistazo a quién es realmente la otra persona."
              }
            ]
          }
        ]
      },
      {
        "title": "Dudas",
        "synopsis": "El compromiso y, después, el miedo que lo rompe.",
        "chapters": [
          {
            "title": "El punto medio",
            "synopsis": "Se entregan a lo que sienten.",
            "scenes": [
              {
                "title": "Compromiso",
                "synopsis": "Un beso, una confesión o una promesa."
              }
            ]
          },
          {
            "title": "La ruptura",
            "synopsis": "La vieja herida o el obstáculo externo ganan, por ahora.",
            "scenes": [
              {
                "title": "Duda",
                "synopsis": "Vuelven los viejos temores."
              },
              {
                "title": "La separación",
                "synopsis": "Se separan, cada uno convencido de tener razón."
              }
            ]
          }
        ]
      },
      {
        "title": "Elegir",
        "synopsis": "Crecimiento, un gran gesto y un futuro compartido.",
        "chapters": [
          {
            "title": "Juntos",
            "synopsis": "Cada uno cambia lo suficiente para merecer al otro.",
            "scenes": [
              {
                "title": "El gran gesto",
                "synopsis": "Uno arriesga todo para demostrar que ha cambiado."
              },
              {
                "title": "Felices para siempre",
                "synopsis": "O felices por ahora: el futuro que eligen."
              }
            ]
          }
        ]
      }
    ]
  }
}
